/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

export enum GrabXDataTypes {
  Boolean = "boolean",
  String = "string",
  Number = "number",
  Json = "json",
}

/**
 * Type mapping from GrabXDataTypes to TypeScript types
 */
export type GrabXDataTypeMap = {
  [GrabXDataTypes.Boolean]: boolean
  [GrabXDataTypes.String]: string
  [GrabXDataTypes.Number]: number
  [GrabXDataTypes.Json]: any
}

// List of facet can be see on BE https://gitlab.myteksi.net/gophers/go/-/blob/master/dispatcher/grab-x/commons/facet/facet.go
export enum FacetTypes {
  City = "city",
  Country = "ctry",
  Merchant = "mex",
  MexMerchant = "mem",
  MexUser = "meu",
  BusinessType = "fbt",
  ServiceName = "svcnm", // non-standard/custom-string
  Mode = "mode", // non-standard/custom-string
}

export type TFacets = { [FacetKey in FacetTypes]?: any }

export interface GrabXFeatureFlag {
  grabxVariableName: string
  dataType: GrabXDataTypes
  defaultValue: any
  facets?: TFacets
}

export interface convertedScribeSDKValue {
  variable_name: string
  feature_value?: any
  feature_value_json?: string
  error?: any
}

export interface GrabXEcomAssetsMobilePath {
  bulkAddProducts: string
}

export interface GrabXMarkOrdersReadyConfig {
  enableMultipleAsync: boolean
  defaultLimitMultipleAsync: number
  defaultLimit: number
  calculationFactor: number
}

export interface GrabXRUMConfig {
  sampleRate: number
  sessionReplaySampleRate: number
  defaultPrivacyLevel: string
  trackLongTasks: boolean
  trackUserInteractions: boolean
  trackResources: boolean
  enableFetchLifecycleActions?: boolean
  ignoreErrorMessages?: string[]
}

export interface GrabXRTKQueryMigrationEndpointsFlag {
  searchOutlets: boolean
  searchStore: boolean
  fetchMerchantDetail: boolean
  fetchItemsWithoutPhotoCount: boolean
  fetchIncidentStat: boolean
  submitReportReview: boolean
  postMerchantReviewThrottle: boolean
  fetchMerchantAggregate: boolean
  fetchIncidentList: boolean
  loadConfig: boolean
  uploadReportReviewImg: boolean
  fetchOrderEta: boolean
  fetchCityList: boolean
  fetchOrderCancelReasons: boolean
  fetchOrderSummary: boolean
  reviewOrderChanges: boolean
  submitOrderChanges: boolean
  cancelOrder: boolean
  fetchOrderExportedMpaFile: boolean
  fetchOrderExportedFile: boolean
  fetchStoreDetailFromMaxAPI: boolean
  fetchOrderByID: boolean
  updateStoreStatus: boolean
  markOrder: boolean
  deleteCategory: boolean
  changeModifierAvailability: boolean
  createMenuGroup: boolean
  upsertItemV2: boolean
  publishMenuGroup: boolean
  deleteMenuGroup: boolean
  deleteItem: boolean
  getTranslation: boolean
  linkItemToModifierGroup: boolean
  resetMenuGroup: boolean
  fetchInventoryExportedFile: boolean
  searchItems: boolean
  editModifierGroup: boolean
  fetchDelvPlatformFeatureFlags: boolean
  fetchInventoryCategory: boolean
  getUserProfileDetail: boolean
  fetchStoreOpenStatus: boolean
  fetchDepartmentsForGrabCategory: boolean
  getVerifyTranslation: boolean
  createModifierGroup: boolean
  getSingleTranslation: boolean
  deleteModifierGroup: boolean
  fetchMenuGroupList: boolean
  fetchSubdepartmentsForGrabCategory: boolean
  proofModifierGroup: boolean
  updateExistingTranslation: boolean
  unLinkItemFromModifierGroup: boolean
  sortDepartments: boolean
  sortItems: boolean
  sortCategories: boolean
  sortDepartmentItems: boolean
  fetchBulkTasks: boolean
  postFeedbackGrabCategory: boolean
  updateItemsAvailableStatus: boolean
  fetchSupportedAttributeCluster: boolean
}
